import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useHospital } from "../components/HospitalContext";
import { animatorDoctorName } from "./animatorDoctorName";
 
//{"age": "old", "gender": "female", "hospital": "soroka", "language": "spanish", "ethnicity": "light"}
const defaultAvatar = {
  age: "middle",
  gender: "male",
  ethnicity: "light",
};

export default function useVideo({ avatar, projectName, hospitalName, language, backgroundDisease = [], data = {}, weekday, dayTime, time, concentrate, Questionnaires, doctorName }) {
  const [video, setVideo] = useState({ src: "" });
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [usedFallback, setUsedFallback] = useState(false);
  const { hospitalData } = useHospital();
  const hasFetched = useRef(false);

  const doFetch = (avatarOverride = null) => {
    const avatarToUse = avatarOverride || avatar || {};
    const { ethnicity, age, gender } = avatarToUse;
    const effectiveProjectName = projectName || "Default Project";
    const hospital = hospitalName || hospitalData?.name;
    const lang = language || "hebrew";

    if (!hospital) return;

    const mergedData = {
      ...data,
      ...(weekday && { weekday }),
      ...(time && { time }),
      ...(dayTime && { time: dayTime }),
      ...(concentrate && { concentrate }),
      ...(Questionnaires && { Questionnaires }),
      ...(doctorName && { doctorName }),
    };
    if (mergedData.doctorName) {
      mergedData.doctorName = animatorDoctorName(mergedData.doctorName, effectiveProjectName);
    }

    const payload = {
      "avatar": {
        "age": age,
        "gender": gender,
        "ethnicity": ethnicity,
        "hospital": hospital,
        "language": lang
      },
      data: mergedData,
      project: { name: effectiveProjectName },
    };

    console.log('Video API Payload:', JSON.stringify(payload, null, 2));
    
    // Check for missing required fields
    const missingFields = [];
    if (!payload.avatar.age) missingFields.push('avatar.age');
    if (!payload.avatar.gender) missingFields.push('avatar.gender');
    if (!payload.avatar.ethnicity) missingFields.push('avatar.ethnicity');
    if (!payload.avatar.hospital) missingFields.push('avatar.hospital');
    if (!payload.avatar.language) missingFields.push('avatar.language');
    
    if (missingFields.length > 0) {
      const errorMsg = `Video API Error: Missing ${missingFields.join(', ')}`;
      console.error(errorMsg);
      console.error('Avatar data:', { age, gender, ethnicity, hospital, lang });
      console.error('Props:', { avatar, hospitalName, hospitalData });
      return;
    }

    axios
      .post(
        //"http://54.88.66.119:8081/api/video/v1/requestLink",
        "https://animator.gistmd.com/api/video/v1/requestLink",
        payload
      )
      .then((res) => {
        console.log('Video API Response:', res.data);
        setVideo(res.data);
        setError(null);
        setRetryCount(0);
      })
      .catch((err) => {
        console.error('Video API Error:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);
        setError(err);

        if (!avatarOverride) {
          // First attempt failed - retry once with fallback avatar
          const hospital = hospitalName || hospitalData?.name;
          const lang = language || "hebrew";
          console.log('Request failed, retrying with fallback avatar');
          setUsedFallback(true);
          setRetryCount(1);
          doFetch({ ...defaultAvatar, hospital, language: lang });
        } else {
          // Fallback also failed - give up
          console.log('Fallback also failed, giving up');
        }
      });
  };

  useEffect(() => {
    hasFetched.current = false;
  }, [projectName]);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true;
      doFetch();
    }
  }, [projectName]);

  // Manual retry function for components to call on player error
  const manualRetry = () => {
    hasFetched.current = false;
    setRetryCount(0);
    setUsedFallback(false);
    setError(null);
    doFetch();
  };

  return { video, error, retryCount, manualRetry, usedFallback };
}
